import React from 'react';
import { useTranslation } from "react-i18next";
import { Input, TextArea } from '@progress/kendo-react-inputs';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { Button } from '@progress/kendo-react-buttons';

export default function GroupFarmsDetailsComponents() {

    const { t } = useTranslation();

    const [value, setValue] = React.useState(new Date());
    const changeDate = ({ value }) => {
        setValue(value);
    };

    return (
        <div>

            <div className="container-fluid mt-4">
                <div className="col-12 col-lg-11 mx-auto">
                    <div className="card">
                        <div className="card-body bg-light py-3">
                            <h5 className="card-title m-0">{t("Global_Label_Text_General")}</h5>
                        </div>

                        <div className="container p-3 p-md-4 d-flex justify-content-center">
                            <div className="row g-4 mb-4" style={{ maxWidth: "900px" }}>

                                <div className="col-12 col-md-6">
                                    <div className="row g-3">
                                        <div className="col-12">
                                            <Input
                                                label={t("Global_Label_Text_Id")}
                                                style={{ width: "50%" }}
                                            />
                                        </div>
                                        <div className="col-12">
                                            <Input
                                                label={t("Global_Label_Text_Description")}
                                                style={{ width: "50%" }}
                                            />
                                        </div>
                                        <div className="col-12">
                                            <Input
                                                label={t("Global_Label_Text_Farms")}
                                                style={{ width: "50%" }}
                                            />
                                        </div>
                                        <div className="col-12">
                                            <Input
                                                label={t("Global_Label_Text_Behavior")}
                                                style={{ width: "50%" }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 col-md-6">
                                    <div className="row g-3">
                                        <div className="col-12">
                                            <Input
                                                label={t("Global_Label_Text_Batch_Template")}
                                                style={{ width: "50%" }}
                                            />
                                        </div>
                                        <div className="col-12">
                                            <Input
                                                label={t("Global_Label_Text_Been")}
                                                style={{ width: "50%" }}
                                            />
                                        </div>
                                        <div className="col-12">
                                            <DatePicker
                                                label={t("Global_Label_Text_Creation_Date")}
                                                show={false}
                                                value={value}
                                                onChange={changeDate}
                                                width={210}
                                            />
                                        </div>
                                        <div className="col-12">
                                            <DatePicker
                                                label={t("Global_Label_Text_Start_Date")}
                                                value={value}
                                                onChange={changeDate}
                                                width={210}
                                            />
                                        </div>
                                        <div className="col-12">
                                            <DatePicker
                                                label={t("Global_Label_Text_End_Date")}
                                                value={value}
                                                onChange={changeDate}
                                                width={210}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="container-fluid mt-4">
                <div className="col-12 col-lg-11 mx-auto">
                    <div className="card">
                        <div className="card-body bg-light py-3">
                            <h5 className="card-title m-0">{t("Global_Label_Text_Remarks")}</h5>
                        </div>

                        <div className="container p-3 p-md-4">
                            <div className="row justify-content-center">
                                <div className="col-12 text-center">
                                    <TextArea
                                        label={t("Global_Label_Text_Remarks")}
                                        rows={3}
                                        style={{ width: "80%" }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid mt-4">
                <div className="col-12 col-lg-11 mx-auto">
                    <div className="d-flex justify-content-end mb-3">
                        <Button className="action-button me-lg-11">{t("Global_Label_Text_Save")}</Button>
                    </div>
                </div>
            </div>

        </div>
    );
}